var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.534 14.333C18.534 16.333 16.8406 17.7331 15.0006 17.7331C13.1606 17.7331 11.4673 16.333 11.4673 14.333H10.334C10.334 16.6063 12.1473 18.4864 14.334 18.8131V20.9997H15.6673V18.8131C17.854 18.4864 19.6673 16.6063 19.6673 14.333M14.2006 10.2663C14.2006 9.82635 14.5606 9.46635 15.0006 9.46635C15.4406 9.46635 15.8006 9.82635 15.8006 10.2663L15.794 14.3997C15.794 14.8397 15.4406 15.1997 15.0006 15.1997C14.5606 15.1997 14.2006 14.8397 14.2006 14.3997M15.0006 16.333C15.5311 16.333 16.0398 16.1223 16.4149 15.7472C16.7899 15.3721 17.0007 14.8634 17.0007 14.333V10.333C17.0007 9.80258 16.7899 9.29387 16.4149 8.9188C16.0398 8.54373 15.5311 8.33301 15.0006 8.33301C14.4702 8.33301 13.9615 8.54373 13.5864 8.9188C13.2114 9.29387 13.0006 9.80258 13.0006 10.333V14.333C13.0006 14.8634 13.2114 15.3721 13.5864 15.7472C13.9615 16.1223 14.4702 16.333 15.0006 16.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.a9e32abfd45814baad008d9a22ebbda6.svg";
export { ForwardRef as ReactComponent };